import { inject, type InjectionKey } from 'vue';

export const applicationRootInjectionKey = Symbol('type') as InjectionKey<string>;

export const useApplicationRoot = () => inject(applicationRootInjectionKey, 'body');
